import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteShippingMethodMutation} from 'api';
import {useSnackbar} from 'notistack';

function ShippingMethodDeleteIconButton({ShippingMethodId}) {
  const [deleteShippingMethod, deleteShippingMethodResult] = useDeleteShippingMethodMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteShippingMethod(ShippingMethodId).unwrap();
      enqueueSnackbar('ShippingMethod deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting ShippingMethod`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete Payment Method</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this Payment Method?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteShippingMethodResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteShippingMethodResult.isLoading}
            color="error"
            endIcon={deleteShippingMethodResult.isLoading ? <CircularProgress size={16} /> : null}
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteShippingMethodResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default ShippingMethodDeleteIconButton;
